import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { BranchPinEntity } from '../../domain/entities/BranchPinEntity'

export class BranchPinModel extends BranchPinEntity {
  constructor(dataDto: BranchPinModel) {
    super()
    mapEntityProperties<BranchPinEntity>(this, dataDto)
  }
}
